<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_ii"><i>This story is dedicated to Damian. I hope it is worthy of the one we could have written together.</i></a></p><a id="page_ii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Dedication.vue?15f25e10